// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"d1292c03","773":"c20bc814"}[chunkId] + ".chunk.js";
};